import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {MatDrawer, MatSidenavModule} from '@angular/material/sidenav';
import {AppLayoutFacadeService} from '../app-layout-facade.service';
import {map, Observable} from 'rxjs';
import {Profile} from '@model/profile';
import {School} from '@model/school';
import {RouterOutlet} from '@angular/router';
import {AsyncPipe} from '@angular/common';
import {SchoolSetting} from '@model/school-setting';
import {SchoolSettingKey} from '@model/school-setting-key';
import {HorizonAppToolbarComponent} from '../horizon-app-toolbar/horizon-app-toolbar.component';
import {HorizonAppSideMenuComponent} from '../horizon-app-side-menu/horizon-app-side-menu.component';
import {AdministrationCredentialsBannerComponent} from '../administration-credentials-banner/administration-credentials-banner.component';

@Component({
    selector: 'app-root-container',
    templateUrl: './app-root-container.component.html',
    styleUrls: ['./app-root-container.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatSidenavModule, RouterOutlet, AsyncPipe,
      HorizonAppToolbarComponent, HorizonAppSideMenuComponent, AdministrationCredentialsBannerComponent
    ]
})
export class AppRootContainerComponent implements OnInit {

  @ViewChild('drawer', {static: false})
  drawer: MatDrawer;

  mobile: boolean;
  sideMenuCollapsed = false;

  profiles$: Observable<Profile[]>;
  selectedProfile$: Observable<Profile>;
  school$: Observable<School>;

  isSuperAdmin: boolean;
  isStaffMember$: Observable<boolean>;
  isAdminStaffMember$: Observable<boolean>;
  isEducatorStaffMember$: Observable<boolean>;
  isTeacherStaffMember$: Observable<boolean>;
  isParent$: Observable<boolean>;
  isStudent$: Observable<boolean>;
  hasAbsenceManagementRole$: Observable<boolean>;
  hasResourceManagementRole$: Observable<boolean>;
  hasIlpManagementRole$: Observable<boolean>;
  hasDisciplinaryManagementRole$: Observable<boolean>;
  hasStudentManagementRole$: Observable<boolean>;
  isMobile$: Observable<boolean>;
  schoolSettings$: Observable<SchoolSetting[]>;
  schoolSynchronizationEnabled$: Observable<boolean>;
  administrationAttendanceAPIIntegrationEnabled$: Observable<boolean>;
  elementarySchool$: Observable<boolean>;
  isAbsenceJustificationValidationEnabled$: Observable<boolean>;
  cabangaLite$: Observable<boolean>;
  administrationCredentialsToConfigure$: Observable<boolean>;

  constructor(private _appFacade: AppLayoutFacadeService,
              private _changeDetector: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.school$ = this._appFacade.school$;
    this.elementarySchool$ = this._appFacade.school$.pipe(
      map(school => school.elementarySchool)
    );
    this.cabangaLite$ = this._appFacade.cabangaLite$;
    this.profiles$ = this._appFacade.profiles$;
    this.selectedProfile$ = this._appFacade.selectedProfile$;
    this.isSuperAdmin = this._appFacade.isSuperAdmin;
    this.isStaffMember$ = this._appFacade.isStaffMember$;
    this.isAdminStaffMember$ = this._appFacade.isAdminStaffMember$;
    this.isEducatorStaffMember$ = this._appFacade.isEducatorStaffMember$;
    this.isTeacherStaffMember$ = this._appFacade.isTeacherStaffMember$;
    this.isParent$ = this._appFacade.isParent$;
    this.isStudent$ = this._appFacade.isStudent$;
    this.hasAbsenceManagementRole$ = this._appFacade.hasAbsenceManagementRole$;
    this.hasResourceManagementRole$ = this._appFacade.hasResourceManagementRole$;
    this.hasIlpManagementRole$ = this._appFacade.hasIlpManagementRole$;
    this.hasDisciplinaryManagementRole$ = this._appFacade.hasDisciplinaryManagementRole$;
    this.hasStudentManagementRole$ = this._appFacade.hasStudentManagementRole$;
    this._appFacade.isMobile$.subscribe(isMobile => {
      this.mobile = isMobile;
      if (this.mobile) {
        this.closeDrawer();
      } else {
        this.openMenu();
      }
    });
    this.isMobile$ = this._appFacade.isMobile$;
    this.schoolSettings$ = this._appFacade.schoolSettings$;
    this.isAbsenceJustificationValidationEnabled$ = this.schoolSettings$.pipe(
      map(settings => settings.find(s => s.key === SchoolSettingKey.ABSENCE_JUSTIFICATION_VALIDATION_ENABLED)),
      map(setting => setting?.enabled === true)
    );
    this.schoolSynchronizationEnabled$ = this._appFacade.schoolSynchronizationEnabled$;
    this.administrationAttendanceAPIIntegrationEnabled$ = this._appFacade.administrationAttendanceAPIIntegrationEnabled$
    this.administrationCredentialsToConfigure$ = this._appFacade.administrationCredentialsToConfigure$;
    this._appFacade.loadSchoolSettings();
  }

  drawerMode() {
    return this.mobile ? 'over' : 'side';
  }

  drawerOpenDefaultState() {
    return !this.mobile;
  }

  openMenu() {
    this.drawer?.open();
    this._changeDetector.markForCheck();
  }

  closeDrawer() {
    if (this.mobile) {
      this.drawer?.close();
    }
    this._changeDetector.markForCheck();
  }

  changeProfile() {
    this._appFacade.changeProfile();
  }

  logout() {
    this._appFacade.logout();
  }

  goToHelp() {
    this._appFacade.goToHelp();
  }

  goToAbout() {
    this._appFacade.goToAbout();
  }

  goToGoogle(appName: string) {
    this._appFacade.goToGoogleApps(appName);
  }

  goToOffice365() {
    this._appFacade.goToOffice365();
  }
}
